var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"left":""}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v(_vm._s(_vm.past))]),_c('span',[_vm._v(_vm._s(_vm.full))])])}
var staticRenderFns = []

export { render, staticRenderFns }